import React from "react";
import { ShieldCheck, Award, Users2, ArrowUpRight } from "lucide-react";

export default function Foundation() {
  return (
    <section id="foundation" className="scroll-mt-28 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="bg-[#373A45] text-white rounded-3xl p-10 md:p-16 relative overflow-hidden">
          <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-[#965EA7]/20 blur-3xl" />
          <div className="absolute -left-16 -bottom-16 h-64 w-64 rounded-full bg-[#965EA7]/10 blur-3xl" />

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <span className="inline-flex items-center rounded-full bg-white/10 px-3 py-1 text-xs font-semibold text-white uppercase tracking-widest">
                Despre Fundația pentru Educație Digitală
              </span>
              <h2 className="mt-4 font-display text-3xl md:text-5xl font-bold leading-[1.15]">
                Construim acces real la educație digitală pentru profesori,
                elevi și școli.
              </h2>
              <div className="mt-5 space-y-4 text-white/80 text-lg leading-relaxed max-w-2xl">
                <p>
                  Fundația pentru Educație Digitală susține proiecte, parteneriate
                  și inițiative educaționale care ajută profesorii, elevii și școlile
                  să se adapteze la transformările digitale și la impactul inteligenței
                  artificiale în educație.
                </p>
                <p>
                  Dezvoltăm programe de formare, resurse practice și inițiative publice
                  care promovează utilizarea responsabilă, etică și aplicabilă a tehnologiei
                  în procesul educațional.
                </p>
              </div>

              <a
                href="https://fped.org/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="foundation-discover-link"
                className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-5 py-2.5 text-sm font-semibold text-white hover:bg-white/10 hover:border-white/40 transition-colors"
              >
                Descoperă fundația
                <ArrowUpRight size={16} aria-hidden="true" />
              </a>

              <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
                {[
                  { icon: <Award size={18} />, title: "Formare profesională", body: "Programe și inițiative dedicate dezvoltării competențelor digitale și integrării AI în educație.", color: "#965EA7" },
                  { icon: <Users2 size={18} />, title: "Impact național", body: "Proiecte, competiții și parteneriate educaționale dezvoltate la nivel național.", color: "#3F8EBA" },
                  { icon: <ShieldCheck size={18} />, title: "Educație digitală responsabilă", body: "Promovăm utilizarea etică, sigură și practică a tehnologiei și inteligenței artificiale.", color: "#519872" },
                ].map((t, i) => (
                  <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-5">
                    <div className="h-9 w-9 rounded-lg grid place-items-center text-white" style={{ backgroundColor: t.color }}>
                      {t.icon}
                    </div>
                    <div className="mt-3 font-semibold">{t.title}</div>
                    <div className="text-sm text-white/70 mt-1">{t.body}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="bg-white/5 border border-white/10 rounded-3xl p-8">
                <div className="text-white/60 uppercase text-xs tracking-widest font-semibold">Misiunea noastră</div>
                <p className="mt-4 font-display text-2xl md:text-3xl font-semibold leading-snug">
                  „Susținem educația digitală prin proiecte concrete, parteneriate
                  și inițiative care ajută profesorii și școlile să se adapteze la
                  lumea de azi."
                </p>
                <div className="mt-6 text-sm text-white/70">
                  — Fundația pentru Educație Digitală
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
